import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8yE-Rrth4WWVpRv_-8uTo0TAsl6bMyqU",
  authDomain: "georgekutti-status.firebaseapp.com",
  projectId: "georgekutti-status",
  storageBucket: "georgekutti-status.firebasestorage.app",
  messagingSenderId: "941131203620",
  appId: "1:941131203620:web:f08ed56336ff8fc6a2c4b1",
  measurementId: "G-2T3P7RNFZV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;
